import type { TinyColor } from "@ctrl/tinycolor";

export function colorString(color: TinyColor) {
    if (color.getAlpha() === 1) {
        return color.toHexShortString();
    }
    return color.toRgbString();
}
